import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-3 error__message-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.$tc('client.identity.changePassword.Title')
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Save'),
                "is-loading": _ctx._isLoading,
                onClick: _ctx.onNext,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "is-loading", "onClick"]),
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Cancel'),
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px",
                "button-style": "btn-secondary"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_g_form, {
                ref: "frmMain",
                "data-object": _ctx.$data
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_g_text_field, {
                        label: _ctx.$tc('account.Password') + '*',
                        mode: "password",
                        "data-mode": "model",
                        "show-label": true,
                        "data-object": _ctx.$data,
                        "data-member": "_password",
                        "validation-rules": { required: true }
                    }, null, 8, ["label", "data-object"]),
                    _createVNode(_component_g_text_field, {
                        label: _ctx.$tc('account.Password.Activate.Confirm') + '*',
                        mode: "password",
                        "data-mode": "model",
                        "show-label": true,
                        "data-object": _ctx.$data,
                        "data-member": "_password2",
                        "validation-rules": { required: true, equals: '_password' }
                    }, null, 8, ["label", "data-object"]),
                    (_ctx._errorMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx._errorMessage), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["data-object"])
        ]),
        _: 1
    }, 8, ["title"]));
}
